import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Pagination } from '~/components/blocks';
import { receptionPageInfoState } from '~/state/reception/atoms';

export const ReceptionPagination = () => {
  const [pageInfo, setPageInfo] = useAtom(receptionPageInfoState);
  const handleChangePage = useCallback(
    (page: number) => {
      setPageInfo((state) => ({ ...state, page }));
    },
    [setPageInfo],
  );

  return (
    <Pagination
      currentPage={pageInfo.page}
      totalPage={pageInfo.totalPage}
      onChange={handleChangePage}
    />
  );
};
